import EntityWithNameStore from "./EntityWithNameStore"

const userGroupStore = new EntityWithNameStore();
export default userGroupStore;


// WEBPACK FOOTER //
// ./web/js/store/userGroupStore.js